import * as actionTypes from '../actionTypes/applicationForm';

export default {
  setResponseStatus: (status) => ({
    type: actionTypes.SET_RESPONSE_STATUS,
    payload: {
      status,
    },
  }),
};
